import { Component, Input } from "@angular/core";
import { IndexSection } from "../store/product-index/state";
import { Environment } from "./environment";
import { trackIndexSection } from "../utils/utils";
import { createDivision } from "../data/model-utils";

@Component({
    selector: "[picker-icon], picker-icon",
    templateUrl: "picker-icon.component.html",
    styleUrls: ["picker-icon.component.css"],
})
export class PickerIconComponent {
    @Input() env: Environment;
    @Input() section: IndexSection;
    @Input() root = true;

    popoverOpen = false;
    boundOffClickHandler = this.offClickHandler.bind(this);
    protected serial = nextSerial++;

    trackSection = trackIndexSection;

    handleButtonPress() {
        if (!this.canAdd) return;
        if (this.products.length > 1) {
            this.popoverOpen = true;
            document.addEventListener("click", this.boundOffClickHandler);
        } else {
            this.createDivision(this.products[0]);
        }
    }

    handleSelect(event, product: IndexSection) {
        if (product.canAdd) {
            this.createDivision(product);
            this.popoverOpen = false;
        }
    }

    offClickHandler(event) {
        if (
            !event.target.closest("#" + this.buttonId) &&
            !event.target.closest("#" + this.popoverId)
        ) {
            document.removeEventListener("click", this.boundOffClickHandler);
            this.popoverOpen = false;
        }
    }

    createDivision(section: IndexSection) {
        const counters = {};
        this.env.protocol.Offers.forEach((offer) => {
            offer.Divisions.forEach((division) => {
                const key = division.Label.split(/\s+\d+$/)[0];
                counters[key] = counters[key] ? counters[key] + 1 : 1;
            });
        });
        let index = counters[section.name.displayName];
        index = index ? index + 1 : 1;

        const newDivision = createDivision(
            section.application,
            "",
            section.category.key,
            section.category.printName,
            section.line.key,
            section.line.displayName,
            section.name.key,
            section.name.displayName,
            section.name.printName,
            index,
        );
        this.env.persistence.addManualDivision(
            this.env.customOffer,
            newDivision,
        );
        if (section.name.key === "erweiterterstrafrechtsschutz") {
            this.addprivatRS(index, section);
        }
    }

    addprivatRS(erweiterIndex: number, section: IndexSection) {
        let privatRSExists = false;
        this.env.protocol.Offers.forEach((offer) => {
            offer.Divisions.forEach((division) => {
                const index = Number(division.Label.match(/\d+$/)[0]);
                if (index === erweiterIndex) {
                    privatRSExists = true;
                }
            });
        });

        if (privatRSExists) {
            return;
        }

        const newDivision = createDivision(
            section.application,
            "",
            section.category.key,
            section.category.printName,
            section.line.key,
            section.line.displayName,
            "privatrechtsschutz",
            "Privat- und Berufs-Rechtsschutz",
            "Privat- und Berufs-Rechtsschutzversicherung",
            erweiterIndex,
        );
        this.env.persistence.addManualDivision(
            this.env.customOffer,
            newDivision,
        );
    }

    get canAdd(): boolean {
        return !!this.products.filter((product) => product.canAdd).length;
    }

    get products(): IndexSection[] {
        return flatMapProducts(this.section);
    }

    get buttonId(): string {
        return "zbd-auswahl-button" + this.serial;
    }

    get popoverId(): string {
        return "zbd-auswahl-pop-over" + this.serial;
    }
}

function flatMapProducts(section: IndexSection): IndexSection[] {
    if (section.items.length === 0) return [section];
    return section.items
        .map(flatMapProducts)
        .reduce((allProducts, products) => allProducts.concat(products), []);
}

let nextSerial = 0;
